import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import img from "@/assets/diventa-socio.jpg";
import { CheckCircle2 } from "lucide-react";

const benefits = [
  "Sostieni un'Associazione attiva da 25+ anni",
  "Partecipa a iniziative e progetti nazionali",
  "Contribuisci alla cultura dell'accessibilità",
  "Accedi a convenzioni e servizi dedicati",
];

const DiventaSocio = () => (
  <>
    <SEO
      title="Diventa socio — FIABA ETS"
      description="Diventando socio di FIABA sostieni un'Associazione che da oltre 25 anni tutela il diritto a una mobilità indipendente e a una vita pienamente accessibile per tutti."
      path="/diventa-socio"
    />
    <PageHero
      eyebrow="Sostienici"
      title="Diventa socio di FIABA"
      subtitle="Entra a far parte di una rete che lavora ogni giorno per un'Italia accessibile e inclusiva."
    />
    <section className="section-padding">
      <div className="container-narrow grid lg:grid-cols-2 gap-12 items-center">
        <img src={img} alt="Stretta di mano e tessera associativa" className="rounded-lg shadow-elegant" loading="lazy" />
        <div className="space-y-5 leading-relaxed text-foreground/90">
          <p>Diventando socio di FIABA avrai la possibilità di sostenere un'Associazione che da oltre 25 anni tutela il diritto a una mobilità indipendente e a una vita pienamente accessibile per tutti.</p>
          <p>Entrare a far parte di FIABA significa anche partecipare attivamente alle iniziative e ai progetti che realizziamo durante l'anno, contribuendo in modo concreto alla diffusione della cultura dell'accessibilità e dell'inclusione.</p>
          <ul className="space-y-3 mt-6">
            {benefits.map((b) => (
              <li key={b} className="flex items-start gap-2">
                <CheckCircle2 className="w-5 h-5 text-secondary shrink-0 mt-0.5" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
          <Link
            to="/contatti"
            className="inline-flex items-center gap-2 bg-gold px-6 py-3 rounded-md font-semibold text-secondary-foreground shadow-gold hover:opacity-90 transition mt-6"
          >
            Richiedi informazioni
          </Link>
        </div>
      </div>
    </section>
  </>
);

export default DiventaSocio;
